// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h5 {
  font-size: 1rem;
  margin-bottom: 8px;
}

.text-remarks {
  color: #FFA500 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/status/status.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":["h5 {\n  font-size: 1rem;\n  margin-bottom: 8px;\n}\n\n.text-remarks {\n  color: #FFA500 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
